import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';

import { AddressFormComponent } from './../../address-form/address-form.component';
import { DialogTaxAddressActionType, DialogTaxAddressData } from './dialog-tax-address.model';

@Component({
  selector: 'act-dialog-tax-address',
  templateUrl: './dialog-tax-address.component.html',
  styleUrls: ['./dialog-tax-address.component.scss']
})
export class DialogTaxAddressComponent implements OnInit {
  public pageElementName = 'dialog-tax-address';
  @ViewChild(AddressFormComponent) addressFormComponent: AddressFormComponent;
  public addressInfo = {
    title: '',
    address: '',
    taxNumber: ''
  };
  public options = { page: this.pageElementName, selectable: false, editable: true };
  public isLoading = false;

  constructor(
    public dialogRef: MdDialogRef<DialogTaxAddressComponent>,
    @Inject(MD_DIALOG_DATA) public address: any) {
    this.address && (this.addressInfo = this.address);
  }

  ngOnInit() {
  }

  handleUpdateAddressInfo(data) {
    this.dialogRef.close(<DialogTaxAddressData>{
      action: data ? DialogTaxAddressActionType.UPDATE_ADDRESS : DialogTaxAddressActionType.CANCEL,
      data: data
    });
  }

  handleCancel() {
    this.dialogRef.close(<DialogTaxAddressData>{
      action: DialogTaxAddressActionType.CANCEL,
      data: undefined
    });
  }

  onSubmit() {
    this.isLoading = true;
    if (!this.addressFormComponent.submitAddressForm()) {
      this.isLoading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-tax-address/dialog-tax-address.component.ts